import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
// import { email } from '@config';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Howdy, My name is</h1>;
  const two = <h2 className="big-heading">Jonathan Dieu.</h2>;
  const three = (
    <h3 className="big-heading">
      I like coding and coffee.
      <span role="img" aria-label="cowboy">
        ☕
      </span>
    </h3>
  );
  const four = (
    <>
      <p>
        I’m a junior studying Computer Science at the University of Central Florida where I serve as
        the President of{' '}
        <a href="https://www.ucfacmw.org/" target="_blank" rel="noreferrer">
          The Association for Computing Machinery.
        </a>
        I previously worked as a cloud infrastructure engineer intern at
        <a href="https://www.docker.com/" target="_blank" rel="noreferrer">
          Docker
        </a>
        , where I learned all about Infrastucture as Code (IaC) by contributing to the flagship
        Docker devtool suite working with Go, Kubernetes, AWS, and Terraform, shipping production
        code for the infrastructure used in supporting roughly 4 billion (yes, with a b) image pulls
        per month as well as 15 million monthly active users. Currently, I'm a software engineer
        intern at{' '}
        <a href="https://www.apple.com/" target="_blank" rel="noreferrer">
          Apple
        </a>
        , where I'm working on TypeScript / Python applications and deploying them onto Kubernetes
        clusters!
      </p>
      <p>
        Though I usually prefer to be compensated for my work on projects- I must admit that I{' '}
        <i>have</i> been known to code in exchange for cookies and other miscellaneous snacks in the
        past- so it never hurts to ask...
      </p>
    </>
  );
  const five = (
    <a
      className="email-link"
      href="https://www.youtube.com/watch?v=kXF3VYYa5TI"
      target="_blank"
      rel="noreferrer">
      Click me for <i>bops</i>!
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
